import React from 'react';
import { Box, ListItem, ListItemText, Typography, Button } from '@material-ui/core';
import { PhoneIphone as PhoneIcon, ChevronRight } from '@material-ui/icons';
import { unpackToDateTime } from '@campfire/hot-date';
import { VolunteerCommonProfileSms } from '../../__generated__/VolunteerCommonProfileSms';

interface OutboundSmsListItemProps {
  sms: VolunteerCommonProfileSms;
  onDetailsClick: () => void;
}

export const OutboundSmsListItem = ({ sms, onDetailsClick }: OutboundSmsListItemProps) => {
  // Extract the message preview (first 50 characters)
  const messagePreview = sms.body.length > 50 ? `${sms.body.substring(0, 50)}...` : sms.body;

  return (
    <Box display='flex' justifyContent='flex-between' key={sms.outboundSmsId}>
      <Box mt='28px' width='85px' position='relative'>
        <Box
          style={{
            display: 'flex',
            backgroundColor: '#83C4A0',
            borderRadius: '3px',
            padding: '4px 8px',
            alignItems: 'center',
            position: 'absolute',
            right: 0,
          }}
        >
          <PhoneIcon style={{ width: '10px', height: '10px', color: '#ffffff', marginRight: '4px' }} />
          <Typography style={{ fontWeight: 600, fontSize: '11px', color: '#ffffff' }}>Sent</Typography>
        </Box>
      </Box>
      <ListItem style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
        <ListItemText
          primary={
            <Typography variant='h6' style={{ fontWeight: 900, fontSize: '14px', color: '#444444' }}>
              {messagePreview}
            </Typography>
          }
          secondary={
            <Typography style={{ fontSize: '10px', color: '#9E9E9E', fontStyle: 'italic' }}>
              {`Sent ${unpackToDateTime(sms.sentAt).toFormat('h:mm a, dd LLLL yyyy')}`}
            </Typography>
          }
        />
        <Box display='flex'>
          <Box
            style={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: '#d9d9d9',
              borderRadius: '3px',
              padding: '4px 8px',
              marginRight: '10px',
            }}
          >
            <PhoneIcon style={{ width: '10px', height: '10px', color: '#545454', marginRight: '4px' }} />
            <Typography style={{ fontWeight: 600, fontSize: '10px', color: '#545454' }}>SMS</Typography>
          </Box>
        </Box>
      </ListItem>
      <Box display='flex' alignItems='center' ml={1}>
        <Button
          onClick={onDetailsClick}
          style={{
            minWidth: 'auto',
            padding: '4px',
            color: '#9E9E9E',
          }}
        >
          <ChevronRight />
        </Button>
      </Box>
    </Box>
  );
};
